import {useRef, useState} from 'react'
import {useParams, useSearchParams} from 'react-router-dom'

import Style from './style'
import ChangeTimerModal from './ui/ChangeTimerModal'
import GiveModal from './ui/GiveModal'

import MainHeader from 'widget/MainHeader'

import useGetEventDetail from 'entity/event/useGetEventDetail'
import usePostEventClose from 'entity/event/usePostEventClose'
import usePostEventInit from 'entity/event/usePostEventInit'
import usePostEventOpen from 'entity/event/usePostEventOpen'
import usePostEventPause from 'entity/event/usePostEventPause'
import usePostEventStart from 'entity/event/usePostEventStart'
import usePostEntryDecrease from 'entity/timer/usePostEntryDecrease'
import usePostEntryIncrease from 'entity/timer/usePostEntryIncrease'

import useEventInfor from 'entity/event/useEventInfor'
import usePostRemaningPlayerAddOn from 'entity/event/usePostRemaningPlayerAddOn'
import useSupabaseRealtime from 'entity/event/useSupabaseRealtime'
import usePostPlayerDecrease from 'entity/timer/usePostPlayerDecrease'
import usePostPlayerIncrease from 'entity/timer/usePostPlayerIncrease'
import usePostReEntryDecrease from 'entity/timer/usePostReEntryDecrease'
import usePostReEntryIncrease from 'entity/timer/usePostReEntryIncrease'
import arrowDownIcon from 'shared/assets/ic_arrow_down.svg'
import minusIcon from 'shared/assets/ic_minus.svg'
import plusIcon from 'shared/assets/ic_plus.svg'
import {
	END,
	PAUSE,
	READY,
	REGISTER,
	TAKING,
} from 'shared/constant/lookup/eventState'
import {STORE} from 'shared/constant/lookup/eventType'
import {
	ROLE_FRANCHISE_MANAGER,
	ROLE_STORE_MANAGER,
} from 'shared/constant/lookup/role'
import useConfirmModalAtom from 'shared/model/useConfirmModalAtom'
import useIsMobile from 'shared/model/useIsMobile'
import useRoleCookie from 'shared/model/useRoleCookie'
import CStyle from 'shared/style/commonStyle'
import ITStyle from 'shared/style/inputTableStyle'
import ConnectionStatus from 'shared/ui/ConnectionStatus'
import DefaultButton from 'shared/ui/DefaultButton'
import EventInfor from 'shared/ui/EventInfor'
import SimpleTabs from 'shared/ui/SimpleTabs'
import JoinedParticipantList from './ui/JoinedParticipantList'
import NotJoinedParticipantList from './ui/NotJoinedParticipantList'
import usePostEarlyIncrease from 'entity/timer/usePostEarlyIncrease'
import usePostEarlyDecrease from 'entity/timer/usePostEarlyDecrease'
import SupabaseConnectError from 'shared/ui/SupabaseConntectError'

const EventParticipantList = () => {
	const {idx} = useParams()
	const [userRole] = useRoleCookie()
	const isMobile = useIsMobile()
	const reEntryRef = useRef(null)

	const [accountSelect, setAccountSelect] = useState()
	const [timerSelect, setTimerSelect] = useState(false)

	const [activeTab, setActiveTab] = useState('joined')
	const [eventData, , eventDataLoading] = useGetEventDetail()

	// 백엔드 데이터 매핑용 State
	const {infoData, success, setInfoData} = useEventInfor(eventData)
	const {
		timeData,
		isLoading,
		countDown,
		supabaseConnectError,
		supabaseConnectErrorStatus,
	} = useSupabaseRealtime(success, setInfoData, eventData)
	const split = countDown ? countDown?.split(':') : ['00', '00']
	const isWarning = split[0] === '00' && parseInt(split[1]) <= 10 ? true : false
	const [startRegister] = usePostEventOpen()
	const [startEvent] = usePostEventStart()
	const [pauseEvent] = usePostEventPause()
	const [initEvent] = usePostEventInit()
	const [closeEvent] = usePostEventClose()
	const [entryIncrease] = usePostEntryIncrease()
	const [entryDecrease] = usePostEntryDecrease()
	const [playerIncrease] = usePostPlayerIncrease()
	const [playerDecrease] = usePostPlayerDecrease()
	const [reEntryIncrease] = usePostReEntryIncrease()
	const [reEntryDecrease] = usePostReEntryDecrease()
	const [earlyIncrease] = usePostEarlyIncrease()
	const [earlyDecrease] = usePostEarlyDecrease()
	const [postRemaningPlayerAddOn] = usePostRemaningPlayerAddOn()

	const [tabCount, setTabCount] = useState({
		joined: '0',
		notJoined: '0',
	})

	const [searchParams, setSearchParams] = useSearchParams()
	const handleTabChange = (tab) => {
		searchParams.set('page', 1)
		searchParams.set('search', '')
		setSearchParams(searchParams)
		setActiveTab(tab)
	}

	const [, setModalEvent] = useConfirmModalAtom()

	const handlePlayerIncrease = () => {
		playerIncrease()
	}

	const handlePlayerDecrease = () => {
		playerDecrease()
	}

	const handleEntryIncrease = () => {
		entryIncrease()
	}

	const handleEntryDecrease = () => {
		entryDecrease()
	}

	const handleReEntryIncrease = () => {
		const selected = reEntryRef.current?.value
		if (selected && selected !== '리엔트리 데이터가 없습니다.') {
			reEntryIncrease(parseInt(selected))
		}
	}

	const handleReEntryDecrease = () => {
		const selected = reEntryRef.current?.value
		if (selected && selected !== '리엔트리 데이터가 없습니다.') {
			reEntryDecrease(parseInt(selected))
		}
	}

	const handleEarlyIncrease = () => {
		earlyIncrease()
	}

	const handleEarlyDecrease = () => {
		earlyDecrease()
	}

	const btnList = []

	// 관리자 라면 추가
	if (![ROLE_STORE_MANAGER, ROLE_FRANCHISE_MANAGER].includes(userRole)) {
		btnList.push({
			label: '접수 시작',
			clickEvent: () =>
				setModalEvent(
					'플레이어들이 대회에 신청 & 참가를 할 수 있게 됩니다.\n접수를 시작하시겠습니까?',
					() => startRegister
				),
			deactive: eventData?.data?.event_state_flag !== READY,
		})
	}

	;[
		{
			label: '대회 시작',
			clickEvent: () =>
				setModalEvent(
					'대회가 시작되면 돌릴 수 없습니다.\n대회를 시작하시겠습니까?',
					() => startEvent
				),
			deactive: eventData?.data?.event_state_flag !== REGISTER,
		},
		{
			label:
				eventData?.data?.event_state_flag === PAUSE
					? '재시작'
					: '대회 일시 정지',
			clickEvent: () => pauseEvent(),
			deactive: [READY, REGISTER, END].includes(
				eventData?.data?.event_state_flag
			),
		},
		{
			label: '대회 종료',
			clickEvent: () =>
				setModalEvent(
					'대회가 종료되면 점수가 반영되며 돌릴 수 없습니다.\n대회를 종료하시겠습니까?',
					() => closeEvent
				),
			deactive: eventData?.data?.event_state_flag !== TAKING,
		},
		{
			label: 'QR 출력',
			clickEvent: () =>
				window.open(`/event/${idx}/qr`, '_blank', 'noopener,noreferrer'),
		},
	].forEach((elem) => btnList.push(elem))

	const subBtnList = [
		{
			label: '타이머 초기화',
			clickEvent: () => initEvent(),
		},
		{
			label: '타이머 특정 레벨로 이동',
			clickEvent: () => setTimerSelect(true),
		},
		{
			label: '에드온 +',
			clickEvent: () => postRemaningPlayerAddOn('increase'),
		},
		{
			label: '에드온 -',
			clickEvent: () => postRemaningPlayerAddOn('decrease'),
		},
		{
			label: '엔트리 +',
			clickEvent: () => entryIncrease(),
		},
		{
			label: '엔트리 -',
			clickEvent: () => entryDecrease(),
		},
		{
			label: '플레이어 +',
			clickEvent: () => playerIncrease(),
		},
		{
			label: '플레이어 -',
			clickEvent: () => playerDecrease(),
		},
	]

	return (
		<>
			<Style.Wrapper>
				<ConnectionStatus />
				<MainHeader
					btnList={btnList}
					mobileLayout='eventParticipant'
					title={eventDataLoading ? '...' : eventData?.data?.name}
				/>
				<EventInfor
					level={timeData?.level || 'N/A'}
					time={countDown || '00:00'}
					players={infoData[0].data}
					entries={infoData[1].data}
					reEntry={infoData[2].data}
					early={infoData[3].data}
					addOn={infoData[4].data}
					avgStackBB={infoData[5].data}
					totalStack={infoData[6].data}
					isLoading={isLoading}
					isWarning={isWarning}
					isMobile={isMobile}
					initEvent={() => initEvent()}
					setTimerSelect={() => setTimerSelect(true)}
				/>
				<Style.SubHeaderContainer>
					<ITStyle.TableDivEvenParticipant
						$showEarly={eventData?.data?.early_end_level != null}
					>
						<ITStyle.TableVerticalElementEvenParticipant
							$isTimer
							$isMobile={isMobile}
						>
							<ITStyle.Timer>타이머</ITStyle.Timer>
							<ITStyle.BtnDefaultContainer>
								<DefaultButton fitWidth small clickEvent={() => initEvent()}>
									타이머 초기화
								</DefaultButton>
								<DefaultButton
									fitWidth
									small
									clickEvent={() => setTimerSelect(true)}
								>
									타이머 특정 레벨로 이동
								</DefaultButton>
							</ITStyle.BtnDefaultContainer>
						</ITStyle.TableVerticalElementEvenParticipant>

						<ITStyle.TableVerticalElementEvenParticipant>
							<h2>에드온</h2>
							<ITStyle.PlusMinusContainer>
								<DefaultButton
									fitWidth
									small
									clickEvent={() => postRemaningPlayerAddOn('increase')}
								>
									<img src={plusIcon} alt='+' />
								</DefaultButton>
								<DefaultButton
									fitWidth
									small
									clickEvent={() => postRemaningPlayerAddOn('decrease')}
								>
									<img src={minusIcon} alt='-' />
								</DefaultButton>
							</ITStyle.PlusMinusContainer>
						</ITStyle.TableVerticalElementEvenParticipant>

						<ITStyle.TableVerticalElementEvenParticipant>
							<h2>플레이어</h2>
							<ITStyle.PlusMinusContainer>
								<DefaultButton fitWidth small clickEvent={handlePlayerIncrease}>
									<img src={plusIcon} alt='+' />
								</DefaultButton>
								<DefaultButton fitWidth small clickEvent={handlePlayerDecrease}>
									<img src={minusIcon} alt='-' />
								</DefaultButton>
							</ITStyle.PlusMinusContainer>
						</ITStyle.TableVerticalElementEvenParticipant>

						<ITStyle.TableVerticalElementEvenParticipant>
							<h2>엔트리</h2>
							<ITStyle.PlusMinusContainer>
								<DefaultButton fitWidth small clickEvent={handleEntryIncrease}>
									<img src={plusIcon} alt='+' />
								</DefaultButton>
								<DefaultButton fitWidth small clickEvent={handleEntryDecrease}>
									<img src={minusIcon} alt='-' />
								</DefaultButton>
							</ITStyle.PlusMinusContainer>
						</ITStyle.TableVerticalElementEvenParticipant>

						<ITStyle.TableVerticalElementEvenParticipant>
							<ITStyle.SelectWrapper>
								<h2>리엔트리</h2>
								<select ref={reEntryRef}>
									{eventData?.data?.re_entry_chip?.length > 0 ? (
										eventData.data.re_entry_chip.map((elem, index) => (
											<option key={index} value={elem}>
												{elem}
											</option>
										))
									) : (
										<option value='리엔트리 데이터가 없습니다.' disabled>
											리엔트리 데이터가 없습니다.
										</option>
									)}
								</select>
								<img src={arrowDownIcon} alt='arrow' />
							</ITStyle.SelectWrapper>
							{/* 리엔트리 데이터가 없습니다. */}
							<ITStyle.PlusMinusContainer>
								<DefaultButton
									fitWidth
									small
									clickEvent={handleReEntryIncrease}
								>
									<img src={plusIcon} alt='+' />
								</DefaultButton>
								<DefaultButton
									fitWidth
									small
									clickEvent={handleReEntryDecrease}
								>
									<img src={minusIcon} alt='-' />
								</DefaultButton>
							</ITStyle.PlusMinusContainer>
						</ITStyle.TableVerticalElementEvenParticipant>

						{eventData?.data?.early_end_level != null && (
							<ITStyle.TableVerticalElementEvenParticipant>
								<h2>얼리</h2>
								<ITStyle.PlusMinusContainer>
									<DefaultButton
										fitWidth
										small
										clickEvent={handleEarlyIncrease}
									>
										<img src={plusIcon} alt='+' />
									</DefaultButton>
									<DefaultButton
										fitWidth
										small
										clickEvent={handleEarlyDecrease}
									>
										<img src={minusIcon} alt='-' />
									</DefaultButton>
								</ITStyle.PlusMinusContainer>
							</ITStyle.TableVerticalElementEvenParticipant>
						)}
					</ITStyle.TableDivEvenParticipant>
				</Style.SubHeaderContainer>
				<div>
					<CStyle.GuideDiv>
						<p>플레이어가 QR 참가를 하면 아래 목록에 추가됩니다.</p>
					</CStyle.GuideDiv>
					<CStyle.GuideDiv>
						<p>
							QR 탈락을 하기 전 까지 순위는 기입되지 않습니다. ( 순위 '-' 표기 )
						</p>
						<p>
							QR 탈락을 늦게한 사람이 높은 순위로 기입됩니다. ( ex. 방금 탈락을
							한 사람이 현 시점 1위 )
						</p>
						<p>
							즉, 누군가 탈락을 하면 전체 순위가 1씩 감소하는 형태로 동작합니다.
						</p>
					</CStyle.GuideDiv>
					<CStyle.GuideDiv>
						<p>
							탈락 취소를 통해 QR 탈락을 취소할 수 있습니다. ( 탈락 하지 않은
							것으로 변경 )
						</p>
						<p>
							순위 변경을 하면 변경한 순위부터 마지막 순위까지 전체 순위가 1씩
							감소합니다.
						</p>
						<p>
							순위를 강제로 입력할 때는, 항상 현재 시점을 기준으로 입력해야
							합니다. ( ex. 탈락자가 한 명도 없다면, 1위로 순위 변경 외에는
							동작하지 않음 )
						</p>
					</CStyle.GuideDiv>
				</div>
				{eventData?.data?.event_type_flag === STORE ? (
					<JoinedParticipantList
						eventData={eventData}
						setAccountSelect={setAccountSelect}
						setTabCount={setTabCount}
					/>
				) : (
					<>
						<SimpleTabs
							tabs={[
								{id: 'joined', label: `참가자 목록 (${tabCount.joined})`},
								{
									id: 'notJoined',
									label: `미참가자 목록 (${tabCount.notJoined})`,
								},
							]}
							activeTab={activeTab}
							onTabChange={handleTabChange}
						/>

						{activeTab === 'joined' && (
							<JoinedParticipantList
								eventData={eventData}
								setAccountSelect={setAccountSelect}
								setTabCount={setTabCount}
							/>
						)}
						{activeTab === 'notJoined' && (
							<NotJoinedParticipantList setTabCount={setTabCount} />
						)}
					</>
				)}
			</Style.Wrapper>

			{accountSelect && (
				<GiveModal
					accountSelect={accountSelect}
					closeEvent={() => setAccountSelect(null)}
				/>
			)}
			{timerSelect && (
				<ChangeTimerModal closeEvent={() => setTimerSelect(false)} />
			)}
			{supabaseConnectError && (
				<SupabaseConnectError
					isVisible={supabaseConnectError}
					status={supabaseConnectErrorStatus}
				/>
			)}
		</>
	)
}

export default EventParticipantList
